
















import Vue from "vue";
import {Component} from "vue-property-decorator";
import Header from "~/components/Header/Header.vue";
import ConfigurationDrawer from "~/components/configuration/ConfigurationDrawer.vue";

@Component<IsiFooter>({
    name: "Isi-Footer"
})

export default class IsiFooter extends Vue {

}
